import { Text, Title } from '@mantine/core'
import type { FormEventHandler, ReactNode } from 'react'
import logo from '../../../../art/brand/thananan-logo-horizontal-black.svg?url'
import classes from './LoginPage.module.css'

/**
 * The frame of the pages someone sees before they are signed in — sign-in, joining by an
 * invite link, asking for an account, a new password: one card on the canvas (full-bleed on a
 * phone), the company's logo (the T and the word, in the text colour so it follows light and dark), a title and a line
 * under it.
 */
export function AuthCard({
  title,
  subtitle,
  onSubmit,
  children,
  wide,
}: {
  title: ReactNode
  subtitle?: ReactNode
  /** Makes the card a form */
  onSubmit?: FormEventHandler<HTMLFormElement>
  children: ReactNode
  /** Room for a longer form */
  wide?: boolean
}) {
  const body = (
    <>
      <span className={classes.logo} role="img" aria-label="Thananan" style={{ maskImage: `url("${logo}")` }} />
      <Title order={1} className={classes.title}>
        {title}
      </Title>
      {subtitle && (
        <Text c="dimmed" size="md" mb="lg">
          {subtitle}
        </Text>
      )}
      {children}
    </>
  )
  const className = wide ? `${classes.card} ${classes.wide}` : classes.card
  return (
    <main className={classes.page}>
      {onSubmit ? (
        <form className={className} onSubmit={onSubmit} noValidate>
          {body}
        </form>
      ) : (
        <div className={className}>{body}</div>
      )}
    </main>
  )
}
